import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { GLAccount } from '../interfaces/gl-account.interface';

@Injectable({
  providedIn: 'root'
})
export class GlAccountService {

  // subjects
  GLAccounts: BehaviorSubject<GLAccount[]>  = new BehaviorSubject<GLAccount[]>(null);

  // endpoints
  glAccountEp = `${this._apiSvc.endpoints.monolith}/api/GLAccount`;

  private _isProcessing = false;

  constructor(
    private _apiSvc: ApiService
  ) { }

  /**
   * Get G/L Accounts
   */
  getGLAccounts(): void {

    if (this._isProcessing) return;

    this._isProcessing = true;

    this._apiSvc.search(this.glAccountEp, {sort: 'FullAccount-asc'})
      .subscribe((res: any) => {
        if (res && res.Data) {
          this.GLAccounts.next(res.Data);
        }
        this._isProcessing = false;
      }, () => {
        this._isProcessing = false;
      });

  }

}
